import { connect } from 'react-redux';
import CancelOrderPage from './CancelOrderPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick, getCancelOrderData } from 'src/actions/liveOrderAction';
import { downloadURL } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
    return {
        cancelOrderData: state.liveOrder.cancelOrderData
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getHoldOrderData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getCancelOrderData);
        },
        reload: () => {
            dispatch(getCancelOrderData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Initial Scan'));
        },
        // submitRework: (column: Object) => {
        //     dispatch(rework(column));
        // },
    };
};

const LiveOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CancelOrderPage);

export default LiveOrderContainer;



// WEBPACK FOOTER //
// ./src/components/CancelOrderPage/CancelOrderPageContainer.tsx